import { Box, Typography } from '@mui/material';

import SectionTitle from './SectionTitle';

interface Props {
  disabled?: boolean;
}

const contents = [
  '尊严与尊重',
  '无论您的年龄、性别、种族、宗教、国籍、社会地位或是否有任何特殊需求，您都将获得适当且专业的医疗服务。您将受到\n同情、尊严与尊重的对待。如果您无法行使您的权利，您的法定监护人或任何依法授权的人将在法律范围内代您行使这些权利。',
  '在探视时间，您有权与家人、朋友和其他访客见面并交谈，除非这些权利因您的整体医疗治疗而受到限制。\n您也有权拒绝访客。',
  '您的特殊需求将受到尊重，无论这些需求是需要语言翻译、特殊宗教饮食要求、设备或护理过程中所需的协助。',
  '在您住院期间，您可以安排自己的精神关怀，并可请求提供任何咨询或牧师支持。',
  '我们的医院将尊重并遵守您根据《预先医疗指示》所做的决定。\n在住院期间，您有权拒绝捐献组织或参与任何形式的医学研究。',
  '*《预先医疗指示》（AMD）是一份法律文件，您提前签署，以告知您的医生，如果您处于终末期且失去意识且死亡迫在眉睫，您不希望使用任何维持生命的治疗来\n延长生命。',
];

const contents2 = [
  '保密与隐私',
  '您的医疗信息以及所有与您相关的护理内容将被保密并保持隐私。您的医疗记录仅由参与治疗您和安排您护理的人员访问。这些记录不会在未经您同意的情况下向任何人披露，除非法律要求或第三方支付合同规定。',
  '您可以根据医院的政策申请一份您的医疗报告副本。您的医疗记录将被保存在安全且受保护的环境中。',
];

const contents3 = [
  '获取有关治疗的信息和解释',
  '您有权以您能够理解的语言（在可能的情况下）获得有关您的医疗状况、治疗及可能结果的信息。这包括可能的风险、副作用以及替代治疗方法的信息。',
  '您有权知道负责您治疗和护理的医疗专业人员的姓名。',
  '所提供的信息将帮助您参与有关您的医疗状况和潜在治疗的决策。',
  '您可以随时获得有关健康教育、自我护理和疾病预防的信息和人员的帮助。',
  '您有权拒绝医疗护理或推荐的治疗，但需在法律允许的范围内。然而，如果您选择不接受治疗或在医生建议下离开医院，您将需要对由此决定可能导致的任何医疗后果负责。您将被简要告知可能的医疗后果。',
];

const contents4 = [
  '财务咨询与费用估算',
  '您有权在入院时获得财务咨询和住院费用的估算。请注意询问任何可能改变初步估算的治疗计划或医疗需求的相关信息。',
  '在住院期间，您有权要求提供这些信息并寻求必要的解释。',
];

const contents5 = [
  '出院时',
  '请随时要求以书面形式提供您的医疗护理说明；我们希望您在家中能够获得所需的信息来照顾自己。请确保您和您的护理人员理解这些说明，并在完全理解之前提出问题。',
  '您的药物必须按照规定服用，如果您对安全性有任何疑虑，请告知您的护士、医生或治疗师。',
  '请确保您拥有医生、诊所、药房和康复服务的姓名及联系信息，以便随时参考。',
];

const PatientsRights = (props: Props) => {
  const { disabled } = props;

  return (
    <>
      <SectionTitle title="患者权利" />
      <Box
        sx={{
          width: '98%',
          margin: '48px auto 24px auto',
          border: '1px solid lightgray',
          padding: '10px',
        }}
      >
        {contents.map((v, i) => {
          if (i === 0) {
            return (
              <Typography
                sx={{
                  fontWeight: '500',
                  fontSize: '12px',
                  lineHeight: '24px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {v}
              </Typography>
            );
          }
          if (i === contents.length - 1) {
            return (
              <Typography
                sx={{
                  fontWeight: '400',
                  fontSize: '14px',
                  lineHeight: '24px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {v}
              </Typography>
            );
          }
          return (
            <Typography
              sx={{
                fontWeight: '400',
                fontSize: '14px',
                lineHeight: '24px',
                whiteSpace: 'pre-wrap',
              }}
            >
              {v}
              <p />
            </Typography>
          );
        })}
      </Box>

      <Box
        sx={{
          width: '98%',
          margin: '48px auto 24px auto',
          border: '1px solid lightgray',
          padding: '10px',
        }}
      >
        {contents2.map((v, i) => {
          if (i === 0) {
            return (
              <Typography
                sx={{
                  fontWeight: '500',
                  fontSize: '12px',
                  lineHeight: '24px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {v}
              </Typography>
            );
          }
          if (i === contents2.length - 1) {
            return (
              <Typography
                sx={{
                  fontWeight: '400',
                  fontSize: '14px',
                  lineHeight: '24px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {v}
              </Typography>
            );
          }
          return (
            <Typography
              sx={{
                fontWeight: '400',
                fontSize: '14px',
                lineHeight: '24px',
                whiteSpace: 'pre-wrap',
              }}
            >
              {v}
              <p />
            </Typography>
          );
        })}
      </Box>

      <Box
        sx={{
          width: '98%',
          margin: '48px auto 24px auto',
          border: '1px solid lightgray',
          padding: '10px',
        }}
      >
        {contents3.map((v, i) => {
          if (i === 0) {
            return (
              <Typography
                sx={{
                  fontWeight: '500',
                  fontSize: '12px',
                  lineHeight: '24px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {v}
              </Typography>
            );
          }
          if (i === contents3.length - 1) {
            return (
              <Typography
                sx={{
                  fontWeight: '400',
                  fontSize: '14px',
                  lineHeight: '24px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {v}
              </Typography>
            );
          }
          return (
            <Typography
              sx={{
                fontWeight: '400',
                fontSize: '14px',
                lineHeight: '24px',
                whiteSpace: 'pre-wrap',
              }}
            >
              {v}
              <p />
            </Typography>
          );
        })}
      </Box>

      <Box
        sx={{
          width: '98%',
          margin: '48px auto 24px auto',
          border: '1px solid lightgray',
          padding: '10px',
        }}
      >
        {contents4.map((v, i) => {
          if (i === 0) {
            return (
              <Typography
                sx={{
                  fontWeight: '500',
                  fontSize: '12px',
                  lineHeight: '24px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {v}
              </Typography>
            );
          }
          if (i === contents4.length - 1) {
            return (
              <Typography
                sx={{
                  fontWeight: '400',
                  fontSize: '14px',
                  lineHeight: '24px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {v}
              </Typography>
            );
          }
          return (
            <Typography
              sx={{
                fontWeight: '400',
                fontSize: '14px',
                lineHeight: '24px',
                whiteSpace: 'pre-wrap',
              }}
            >
              {v}
              <p />
            </Typography>
          );
        })}
      </Box>

      <Box
        sx={{
          width: '98%',
          margin: '48px auto 24px auto',
          border: '1px solid lightgray',
          padding: '10px',
        }}
      >
        {contents5.map((v, i) => {
          if (i === 0) {
            return (
              <Typography
                sx={{
                  fontWeight: '500',
                  fontSize: '12px',
                  lineHeight: '24px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {v}
              </Typography>
            );
          }
          if (i === contents5.length - 1) {
            return (
              <Typography
                sx={{
                  fontWeight: '400',
                  fontSize: '14px',
                  lineHeight: '24px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {v}
              </Typography>
            );
          }
          return (
            <Typography
              sx={{
                fontWeight: '400',
                fontSize: '14px',
                lineHeight: '24px',
                whiteSpace: 'pre-wrap',
              }}
            >
              {v}
              <p />
            </Typography>
          );
        })}
      </Box>
    </>
  );
};

export default PatientsRights;
